export default __webpack_public_path__ + "static/thomson-reuters-icon-75e97b6c9ffec93451c43460bf036ed5.svg";